import { useEffect, useRef, useState } from "react";

import DocumentRow from "../../DocumentRow/DocumentRow";
import PanelActionBarComponent from "../../common/PanelActionBarComponent";
import CounselIcon from "../../../../public/BP_resources/images/icon/litigation-icon-color.svg";
import InformationPanel from "../../common/InformationPanel";
import ContactPanelForTreatment from "../../TreatmentPage/components/ContactPanelForTreatment";
// import LitigationNotesPanel from "../../LitigationDashboard/LitigationTabInfo/LitigationNotesPanel";
import VerifiedIcon from "../../../assets/verified_yes.png";
import NonVerifiedIcon from "../../../assets/verifiedno.png";
import TreatmentNotesSection from "../../TreatmentPage/NotesTreatmentSection";
import { currencyFormat } from "../../../Utils/helper";

import CounselEditPopup from "./popups/CounselEditPopup";
import "../../common/RecordPanel.css";

function CounselMain({
  opposingcounsel,
  _entity_name,
  For_instance_name,
  handleFacthDefendants,
  setForDeleteCounselId,
  showDeleteCounselConfirm,
  isDef = false,
  isParty = false,
}) {
  const [counselEditModal, setCounselEditModal] = useState(false);
  const [activeTab, setActiveTab] = useState("counsel");

  const handleCounselEditModal = (tab) => {
    setCounselEditModal(true);
    setActiveTab(tab);
  };

  const handleDeleteConfirmPopup = () => {
    setCounselEditModal(false);
    setForDeleteCounselId(opposingcounsel?.id);
    showDeleteCounselConfirm(true);
  };

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const EmploymentButtonsConfig2 = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-19 ic-avatar has-avatar-icon has-cover-img m-l-5",
      imgSrc: hoveredIndex ? VerifiedIcon : NonVerifiedIcon,

      imgClassName: "ic ic-19 m-r-5",
      buttonText: "9/20/25 10:30 AM",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onHover: () => {
        setHoveredIndex(true);
      },
      onMouseLeave: () => {
        setHoveredIndex(null);
      },
      onClick: () => {
        setHoveredIndex(true);
      },
    },
  ];

  const CounselButtons = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: () => {},
    },
  ];

  const [height, setHeight] = useState(null);
  const counselRef = useRef(null);

  useEffect(() => {
    if (counselRef.current) {
      setHeight(counselRef.current.clientHeight);
    }
  }, [counselRef]);
  return (
    <>
      <div className="report record-panel" style={{ position: "relative" }}>
        <PanelActionBarComponent
          compact
          panelIconSrc={CounselIcon}
          page_id={64}
          instanceForName={"Counsel"}
          id={opposingcounsel?.id}
          forInstanceName={For_instance_name}
          name={isParty ? For_instance_name : For_instance_name}
          type={isParty ? For_instance_name : opposingcounsel?.counsel_type?.name}
          {...(isParty && {
            hasIcon: true,
            iconClassName: "counsel",
          })}
        />
        <div
          className="d-flex record-panel-body flex-wrap"
          style={{
            gap: "5px",
          }}
        >
          <div ref={counselRef} className="leins-container-four m-b-5">
            <div className="min-w-260px-client">
              <ContactPanelForTreatment
                name={opposingcounsel?.opposingcounselcontact?.name}
                panel_name={"Law Firm"}
                pageName="Defendants"
                className="m-b-0"
                dynamic_label={"Opposing Counsel Name"}
                phone_number={opposingcounsel?.opposingcounselcontact?.phone_number}
                fax_number={opposingcounsel?.opposingcounselcontact?.fax}
                email={opposingcounsel?.opposingcounselcontact?.email}
                address1={opposingcounsel?.opposingcounselcontact?.address1}
                address2={opposingcounsel?.opposingcounselcontact?.address2}
                city={opposingcounsel?.opposingcounselcontact?.city}
                state={opposingcounsel?.opposingcounselcontact?.state}
                zip_code={opposingcounsel?.opposingcounselcontact?.zip}
                ext={opposingcounsel?.opposingcounselcontact?.phone_ext}
                websiteURL={opposingcounsel?.opposingcounselcontact?.website}
                buttonData={CounselButtons}
                onSelectObject={() => handleCounselEditModal("counsel")}
                genrate_doc_address={0}
                templateDropdownId={0}
                templatePageId={64}
              />
            </div>
            <div className="min-w-260px-client">
              {/* <InformationPanel
                panel_name={"Service"}
                className="m-b-0"
                pageName={"defendant_counsel"}
                panelClassName="m-b-0"
                data={[]}
                onSelectReport={() => {}}
                hasBtn={true}
                buttonData={EmploymentButtonsConfig2}
              /> */}
              <ContactPanelForTreatment
                name={`${opposingcounsel?.supervisor?.first_name || ""} ${opposingcounsel?.supervisor?.last_name || ""}`}
                className="m-b-0"
                panel_name={"Supervising Attorney"}
                pageName="Defendants"
                phone_number={opposingcounsel?.supervisor?.phone_number}
                fax_number={opposingcounsel?.supervisor?.fax}
                email={opposingcounsel?.supervisor?.email}
                address1={opposingcounsel?.supervisor?.address1}
                address2={opposingcounsel?.supervisor?.address2}
                city={opposingcounsel?.supervisor?.city}
                state={opposingcounsel?.supervisor?.state}
                zip_code={opposingcounsel?.supervisor?.zip}
                ext={opposingcounsel?.supervisor?.phone_ext}
                websiteURL={opposingcounsel?.supervisor?.website}
                buttonData={CounselButtons}
                onSelectObject={() => handleCounselEditModal("supervisor")}
                genrate_doc_address={0}
                templateDropdownId={0}
                templatePageId={64}
              />
            </div>
            <div className="min-w-260px-client">
              <ContactPanelForTreatment
                name={`${opposingcounsel?.opposingattorney?.first_name || ""} ${opposingcounsel?.opposingattorney?.last_name || ""}`}
                className="m-b-0"
                panel_name={"Main Attorney"}
                pageName="Defendants"
                phone_number={opposingcounsel?.opposingattorney?.phone_number}
                fax_number={opposingcounsel?.opposingattorney?.fax}
                email={opposingcounsel?.opposingattorney?.email}
                address1={opposingcounsel?.opposingattorney?.address1}
                address2={opposingcounsel?.opposingattorney?.address2}
                city={opposingcounsel?.opposingattorney?.city}
                state={opposingcounsel?.opposingattorney?.state}
                zip_code={opposingcounsel?.opposingattorney?.zip}
                ext={opposingcounsel?.opposingattorney?.phone_ext}
                websiteURL={opposingcounsel?.opposingattorney?.website}
                buttonData={CounselButtons}
                onSelectObject={() => handleCounselEditModal("attorney")}
                genrate_doc_address={0}
                templateDropdownId={0}
                templatePageId={64}
              />
            </div>

            <div className="min-w-260px-client">
              <InformationPanel
                panel_name={"Information"}
                className="m-b-0"
                pageName={"defendant_counsel"}
                panelClassName="m-b-0"
                data={[
                  {
                    label: "Type",
                    value: opposingcounsel?.counsel_type?.name,
                  },
                  {
                    label: "File",
                    value: opposingcounsel?.file_number,
                  },
                  { label: "Original Lien", value: currencyFormat(opposingcounsel?.orignal_lien) },
                  { label: "Final Lien", value: currencyFormat(opposingcounsel?.final_lien) },
                ]}
                onSelectReport={() => handleCounselEditModal("information")}
                hasBtn={true}
                buttonData={EmploymentButtonsConfig2}
              />
            </div>
          </div>
          {/* <div className="d-flex d-flex-1 p-l-5 m-b-5 overflow-hidden">
            <NotesPanel
              entity_type={"Counsel"}
              record_id={opposingcounsel?.id}
              module={"Counsel"}
              notesName={"Counsel"}
            />
          </div> */}
          {/* <LitigationNotesPanel
            entity_type="Counsel"
            record_id={opposingcounsel?.id}
            notesName={"Counsel"}
          /> */}
          <div
            className=""
            style={{
              flex: 1,
              minHeight: "160px",
              paddingRight: "0px",
              scrollbarWidth: "none",
              minWidth: "min(400px, 100%)",
              maxHeight: `${height}px`,
            }}
          >
            <p className="menu-bar-style columnsTitle text-center">Notes</p>
            <TreatmentNotesSection
              entity_type={"Counsel"}
              record_id={opposingcounsel?.id}
              module={"Counsel"}
              notesName={"Counsel"}
              instanceFor="Defendants" //to show height with respect to defendants page
              pagePanels={4}
            />
          </div>
        </div>
        <div className=" documents-wrapper">
          <div className="col-12">
            <DocumentRow clientProvider={opposingcounsel} page_id={64} showSaveToPage={false} />
          </div>
        </div>
      </div>

      {counselEditModal && (
        <CounselEditPopup
          show={counselEditModal}
          handleClose={() => setCounselEditModal(false)}
          activeTab={activeTab}
          opposingcounsel={opposingcounsel}
          handleFacthDefendants={handleFacthDefendants}
          onShowDeleteConfirmPopup={handleDeleteConfirmPopup}
          CounselButtons={CounselButtons}
          isDef={isDef}
        />
      )}
    </>
  );
}

export default CounselMain;
